export interface OperacionesFilter {
  id?: number;

  fechaDesde?: string; // yyyy-MM-dd o yyyy-MM-dd HH:mm:ss
  fechaHasta?: string;

  vendedor?: number;
  cliente?: number;

  total?: number;

  operacion?: number; // enum ordinal
  estado?: number; // enum ordinal
  tipoOperacion?: number; // enum ordinal

  tipoPrecio?: string; // enum name (ej: 'PUBLICO', 'MAYORISTA')
  mayorista2?: boolean;
  mayorista2Modo?: string; // enum name

  entrega?: number; // enum ordinal
  envio?: number; // enum ordinal

  page?: number;
  size?: number;
}

export enum TipoOperacion {
  MAYORISTA = 0,
  MINORISTA = 1,
}

export enum Entrega {
  LOCAL = 0,
  ENVIO = 1,
  DESPACHO = 2,
}

export enum Envio {
  ACONFIRMAR = 0,
  CONFIRMADO = 1,
  PREPARADO = 2,
  ENVIADO = 3,
  ENTREGADO = 4,
  ENPREPARACION = 5,
  FALTAPAGO = 6,
  ELIMINAR = 7,
  PAGADO = 8,
}

export enum Estado {
  NUEVO = 0,
  VISTO = 1,
  CERRADO = 2,
  PAGADO = 3,
  PENDIENTE = 4,
  ELIMINADA = 5,
  CONTRAREEMBOLSO = 6,
  CTASUELDO = 7,
  INICIADA = 8,
}

export enum TipoPrecio {
  PUBLICO = 0,
  MAYORISTA = 1,
  MAYORISTA2 = 2,
  INTERNA = 3,
}

export enum Mayorista2Modo {
  AUTO = 0,
  MANUAL = 1,
}

export enum Op {
  VENTA = 0,
  ECOMMERCE = 1,
  PRESUPUESTO = 2,
  INTERNA = 3,
  INTERNASUELDO = 4,
}

export interface RespuestaGenerica {
  timeStamp: string;
  codigoRespuesta: string;
  mensaje: string;
  data: {
    content: any[];
    page: PageInfo;
  };
}

export interface PageInfo {
  size: number;
  number: number;
  totalElements: number;
  totalPages: number;
}
